import QRCode from 'qrcode';

/** Vector QR for the report header. Medium error correction survives smudged printouts. */
export async function qrSvg(url: string): Promise<Uint8Array> {
  const svg = await QRCode.toString(url, { type: 'svg', errorCorrectionLevel: 'M', margin: 0 });
  return new TextEncoder().encode(svg);
}
